module.exports = __webpack_public_path__ + "img/logo-ccr3-white.c7da422c.svg";